import { render, staticRenderFns } from "./ExternalOrderItem.vue?vue&type=template&id=79b3e49f&"
import script from "./ExternalOrderItem.vue?vue&type=script&lang=js&"
export * from "./ExternalOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports